import { OrderFields } from "../../../constants";
import type { TAddressRequestParams, TNewAddressForm } from "../types";

const mapNewResponseErrorsToFields = (
  errors: Partial<Record<keyof TAddressRequestParams, string>>
): Partial<Record<keyof TNewAddressForm, string>> => ({
  [OrderFields.NEW_ADDRESS_NAME]: errors.contactName,
  [OrderFields.NEW_ADDRESS_PHONE]: errors.contactPhone,
  [OrderFields.NEW_ADDRESS_EMAIL]: errors.contactEmail,
  [OrderFields.DESTINATION_COUNTRY]: errors.countryCode,
  [OrderFields.NEW_ADDRESS_LOCKER]: errors.lockerId,
  [OrderFields.NEW_ADDRESS_STREET]: errors.street,
  [OrderFields.NEW_ADDRESS_HOUSE_NO]: errors.streetNumber,
  [OrderFields.NEW_ADDRESS_FLAT_NO]: errors.flatNo,
  [OrderFields.NEW_ADDRESS_CITY]: errors.city,
  [OrderFields.NEW_ADDRESS_ZIP_CODE]: errors.zip,
});
export default mapNewResponseErrorsToFields;
